const authBasePrefix = '/api/Auth';
export const auth = {
  // login: () => `${authBasePrefix}/login`,
  startLogin: () => `${authBasePrefix}/startlogin`,
  confirmLogin: () => `${authBasePrefix}/confirmlogin`,
  loginResendSms: () => `${authBasePrefix}/resend-sms`,
  logout: () => `${authBasePrefix}/logout`,
  // twoFactor: () => '/auth/2factor',
  refreshToken: () => `${authBasePrefix}/refresh`,
  recovery: () => `${authBasePrefix}/recovery`,
  recoveryConfirmation: () => `${authBasePrefix}/recovery/confirmation`,
  // recoveryResendSms: () => `${authBasePrefix}/recovery/resend-sms`,
  changePassword: () => `${authBasePrefix}/change-password`,
};

const registerBasePrefix = '/api/Register';
export const register = {
  registerFirst: () => `${registerBasePrefix}/login`,
  registerVerify: () => `${registerBasePrefix}/verify`,
  registerFinal: () => `${registerBasePrefix}/register`,
  registerResendSms: () => '/user/register/resend-sms',
};

const accountsBasePrefix = '/api/Accounts';
export const accounts = {
  getAccountsCardsAccess: () => `${profileBasePrefix}/UserAccountsCardsAccess`,
  getCards: (itemType: string, itemId: string | number) => `${accountsBasePrefix}/${itemType}/${itemId}/Cards`,
  getLimits: (itemType: string, itemId: string | number) => `${accountsBasePrefix}/${itemType}/${itemId}/Limits`,
  getExpirations: (itemType: string, itemId: string | number) => `${accountsBasePrefix}/${itemType}/${itemId}/Expiry`,
  getCardPhone: (cardId: string | number) => `${accountsBasePrefix}/Card/${cardId}/Mobile`,
  requestSupplement: () => `${accountsBasePrefix}/RequestSupplementCard`,
  remindPin: () => `${accountsBasePrefix}/ResendPIN`,
  changeLimit: () => `${accountsBasePrefix}/RequestNewCreditLimit`,
  blockCard: () => `${accountsBasePrefix}/BlockCard`,
};

const profileBasePrefix = '/api/Profile';
export const profile = {
  getAccounts: () => `${profileBasePrefix}/UserAccountsCardsAccess`,
  getAccountsCardsAccess: () => `${profileBasePrefix}/UserAccountsCardsAccess`,
  getUserProfile: (accountId: string) => `${profileBasePrefix}/${accountId}`,
  postUserProfile: (accountId: string) => `${profileBasePrefix}/${accountId}`,
  updateProfile: (accountId: number) => `${profileBasePrefix}/updateProfile/${accountId}`,
  sendCodeToMobile: () => `${profileBasePrefix}/sendCodeToMobile`,
  sendCodeToEmail: () => `${profileBasePrefix}/sendCodeToEmail`,
};

const messagesBasePrefix = '/api/Messages';
export const messages = {
  getMessagesCount: () => `${messagesBasePrefix}/Count/UnreadRefresh`,
  getMessagesThread: (threadId: string) => `${messagesBasePrefix}/${threadId}`,
  getMessagesThreads: () => messagesBasePrefix,
  getMessageFile: (messageId: string, filename: string) => `${messagesBasePrefix}/${messageId}/${filename}`,
  postMessage: () => messagesBasePrefix,
  deleteMessagesThread: (threadId: string) => `${messagesBasePrefix}/${threadId}`,
};

export const misc = {
  getDictionaries: () => '/dictionaries',
};

const resourceBasePrefix = '/api/Resource';
export const resource = {
  getProductImageInfo: (name: string) => `${resourceBasePrefix}/Cards/${name}`,
  getProductImage: (name: string) => `${resourceBasePrefix}/Cards/${name}/Download`,
  getResources: () => resourceBasePrefix,
  getTC: (productName: string) => `${resourceBasePrefix}/TC/${productName}/Stream`,
  getCardAgreements: (name: string) => `${resourceBasePrefix}/CardAgreements/${name}`,
  getCardAgreementsDoc: (name: string, file: string) => `${resourceBasePrefix}/CardAgreements/${name}/${file}`,
  getFooterContent: () => `${resourceBasePrefix}/TC/footer`,
};

const statementsBsePrefix = '/api/Statements';
export const statements = {
  getStatements: (id: number) => `${statementsBsePrefix}/${id}`,
  getStatementsByCard: (id: string) => `${statementsBsePrefix}/Card/${id}`,
  downloadStatement: (accountId: string, year: string, month: string) => `${statementsBsePrefix}/Download/${accountId}/${year}/${month}`,
  downloadStatementByCard: (cardId: string, year: string, month: string) => `${statementsBsePrefix}/Download/Card/${cardId}/${year}/${month}`,
};

const transactionsBasePrefix = '/api/Transactions';
export const transactions = {
  getTransactions: (id: string) => `${accountsBasePrefix}/${id}/transactions`,
  getCardTransactions: (accountId: number, cardId: number) => `${transactionsBasePrefix}/${accountId}/${cardId}`,
  downloadTransactions: (accountId: number, cardId: number) => `${transactionsBasePrefix}/${accountId}/${cardId}/download`,
};
